import { html } from "lit";
export const defaultCodeRender = options => html `<ch-code
    .language=${options.language}
    .lastNestedChildClass=${options.lastNestedChildClass}
    .showIndicator=${options.showIndicator}
    .value=${options.plainText}
  ></ch-code>`;
